import { ReactNode } from 'react'
import { BadgeWrapper } from '$common/badge/styled-badge'
import { RemovePersonIcon } from '$common/icons/remove-person'
import { AvatarBase, AvatarBaseProps } from '$common/avatar/avatar-base'

export interface SelectableAvatarProps
  extends Omit<AvatarBaseProps, 'children' | 'hasBorder'> {
  avatarBackgroundText: ReactNode
  checked?: boolean
  online?: boolean
}

export function SelectableAvatar({
  avatarBackgroundText,
  checked = false,
  online = false,
  hasDeleted,
  ongoingCallType,
  ...rest
}: SelectableAvatarProps) {
  return (
    <BadgeWrapper
      selected={checked}
      online={online}
      ongoingCallType={ongoingCallType}
    >
      <AvatarBase
        hasDeleted={hasDeleted}
        ongoingCallType={ongoingCallType}
        {...rest}
      >
        {hasDeleted ? <RemovePersonIcon /> : avatarBackgroundText}
      </AvatarBase>
    </BadgeWrapper>
  )
}
